import StepDrawer from './StepDrawer';

const presetPackages = [
    {
        name: "Bilateral Hip and Low Back",
        attributes: [{name: "Right Hip"}, {name: "Left Hip"},{name:  "Right Low Back"},{name: "Left Low Back"}],
    },
    {
        name: "Bilateral Hip",
        attributes: [{name: "Right Hip"}, {name: "Left Hip"}],
    },
    {
        name: "Bilateral Low Back",
        attributes: [{name: "Right Low Back"}, {name: "Left Low Back"}],
    },
];

function PainDiaryPackages({
    currentStep,
    totalSteps,
    diary,
    setDiary,
    close,
    onContinue
}) {

    const selectGenericPackage = (pkg) => {
        let newDiary = {
            ...diary,
            attributes: pkg.attributes,
            custom: false
        }
        setDiary(newDiary)
        onContinue(newDiary)
    };

    const selectCustomPackage = () => {
        let newDiary = diary.custom ? {
            ...diary
        } : {
            ...diary,
            attributes: [{ name: "" }],
            custom: true
        }
        setDiary(newDiary)
        onContinue(newDiary)
    };

    return (
        <StepDrawer
            currentStep={currentStep}
            totalSteps={totalSteps}
            title="Create Your Pain Diary"
            disabled={!diary.attributes?.[0]?.name}
            onCancel={close}
            onContinue={() => onContinue(diary)}
        >
            <div style={{ display: "grid", gap: "1rem" }}>
                <p className="selection-hint" style={{ color: 'rgb(156, 163, 175)' }}>Choose which areas you want to track.</p>
                {presetPackages.map((pkg) => (
                    <div
                        key={pkg.name}
                        style={{
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            padding: "1rem",
                            cursor: "pointer",
                            transition: "box-shadow 0.2s ease",
                            background: "white"
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)")}
                        onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
                    >
                        <h2 style={{ fontSize: "1.2rem", fontWeight: "600", marginBottom: "0.5rem" }}>
                            {pkg.name}
                        </h2>
                        <p style={{ fontSize: "0.9rem", color: "#666", marginBottom: "1rem" }}>
                            {pkg.attributes.map(metric => metric.name).join(", ")}
                        </p>
                        <button
                            className="create-review-button"
                            style={{ display: 'inline' }}
                            onClick={() => selectGenericPackage(pkg)}
                        >
                            Select
                        </button>
                    </div>
                ))}

                <div
                    style={{
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        padding: "1rem",
                        cursor: "pointer",
                        transition: "box-shadow 0.2s ease",
                        background: "white"
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)")}
                    onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
                >
                    <h2 style={{ fontSize: "1.2rem", fontWeight: "600", marginBottom: "0.5rem" }}>
                        Custom
                    </h2>
                    <p style={{ fontSize: "0.9rem", color: "#666", marginBottom: "1rem" }}>
                        Customize the areas you want to track
                    </p>
                    <button
                        className="create-review-button"
                        style={{ display: 'inline' }}
                        onClick={selectCustomPackage}
                    >
                        Select
                    </button>
                </div>
            </div>
        </StepDrawer>
    )
}

export default PainDiaryPackages;